import { connect, MapStateToProps } from 'react-redux';
import { getIsCurrentUserAuthorOf } from '../../redux/deviations/selectors';
import { Props } from './MoreActionsButton';

export type StateProps = Pick<Props, 'isOwner'>;
export type OwnProps = Omit<Props, keyof StateProps>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, any> = (state, { deviation }) => ({
  isOwner: getIsCurrentUserAuthorOf(state, deviation),
});

export default connect(mapStateToProps);
